import * as FlatModels from '@medsurf/flat-models';
import { Color } from "paper";

/**
 * Format Defaults
 */
class FormatDefaults {
  public canvas: {width: number, height: number} = {
    width: 600,
    height: 600
  };
  public color = '#000000';
  public backgroundColor = '#fafafa';
  public fontColor: Color | string | null = '#000000';
  public fontFamily = 'Figtree';
  public fontWeight = '600';
  public fontSize = 12;
  public leading: {label: number, tooltip: number} = {label: 1, tooltip: 1.2};
  public strokeColor: Color |string | null = '#000000';
  public blendMode = 'normal';
  public strokeWidth = 1;
  public fillColor: Color | string | null = '#000000';
  public justification = 'left';
  public pivot = '';
  public selection: { radius: number, strokeWidth: number, color: string, opacity: number} = {
    radius: 4,
    strokeWidth: 2,
    color: '#4A90E2',
    opacity: 0.4
  };
  public border: {fillColor: string, strokeColor: string, blendMode: string, strokeWidth: number, cornerRadius: number} = {
    fillColor: '#ffffff',
    strokeColor: '#000000',
    blendMode: 'normal',
    strokeWidth: 1,
    cornerRadius: 2
  };
  public circleRadius = 4;
}

/**
 * Format
 */
export class Format extends FormatDefaults {
  /**
   * Constructor
   *
   * @param defaults
   */
  constructor (defaults?: FlatModels.PageEntityModels.Defaults) {
    super();
    if (defaults) {
      if (defaults.labelColor) {
        this.fontColor = defaults.labelColor;
      }
      if (defaults.labelFontSize) {
        this.fontSize = defaults.labelFontSize;
      }
      if (defaults.pointerColor) {
        this.fillColor = defaults.pointerColor;
        this.strokeColor = defaults.pointerColor;
      }
    }
  }

  /**
   * Set Marker Format
   *
   * @param models
   */
  setMarkerFormat(models: FlatModels.ImageSharedModels.ElementModels) {
    if (models.label) {
      if (models.label.fontSize) {
        this.fontSize = models.label.fontSize;
      }
      if (models.label.color) {
        this.fontColor = models.label.color;
      }
      if (models.label.align) {
        this.justification = models.label.align;
      }
      if (models.label.pivot) {
        this.pivot = models.label.pivot;
      }
    }

    if (models.annotation.type !== FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
      const otherModels = (<FlatModels.ImageSharedModels.MarkerModel & FlatModels.ImageSharedModels.KeymapModel>models);
      if ((otherModels.targets || []).length > 0) {
        if (otherModels.targets[0].endType && otherModels.targets[0].endRadius) {
          this.circleRadius = otherModels.targets[0].endRadius;
        }
        if (otherModels.targets.some(target => !!target.color)) {
          const strokeColor = otherModels.targets.find(target => !!target.color)?.color;
          if (strokeColor) {
            this.strokeColor = strokeColor;
          }
        }
      }
    }

    if (models.annotation.type === FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
      const freeFromModels = (<FlatModels.ImageSharedModels.FreeformModel>models);
      if (freeFromModels.target?.endRadius) {
        this.circleRadius = freeFromModels.target.endRadius;
      }
      if (freeFromModels.target?.color) {
        this.strokeColor = freeFromModels.target.color;
      }
    }
  }
}
